//FILESERVER PATH
export const FILESERVER_PATH = "http://18.231.31.53:6000/api/";

//REDUX MANAGEMENT CONSTANTS
export const UPLOADFILE = "uploadfile";
export const DOWNLOADFILE = "downloadfile";
export const LISTFILES = "listfiles";
export const CLEARFILES = "clearfiles";
export const GETFILELINK = "getfilelink";
export const FILESUPLOADED = "FILESUPLOADED";
//Authentication
export const AUTHSUCCESS = "AUTHSUCCESS";
export const AUTHFAILED = "AUTHFAILED";
export const AUTHRESET = "AUTHRESET";

//Clinic Data
export const CLINICDATA = "CLINICDATA";

//File Server
export const FILESERVER = "FILESERVER";

//Update row
export const UPDATEROW = 'UPDATEROW';

//Attachments
export const LISTATTACHMENTS = 'LISTATTACHMENTS';
export const FILEVIEWER = 'FILEVIEWER';
export const SUPPORTINGDOCUMENTS = 'SUPPORTINGDOCUMENTS';


//Create Case
export const CREATECASE_FAILED = "CREATECASE_FAILED";
export const CREATECASE_SUCCESS = "CREATECASE_SUCCESS";
export const CREATECASE_RESET = "CREATECASE_RESET";
export const SELECTEDCASE = "SELECTEDCASE";
//Clinic Dashboard
export const LISTACTIVECASES = 'LISTACTIVECASES';
export const LISTINACTIVECASES = 'LISTINACTIVECASES';
export const GETTABLESBYPOLNUM = 'GETTABLESBYPOLNUM';

//Working tables
export const WORKINGTABLES = "WORKINGTABLES";
export const CLINICS = 'CLINICS';

//Actisure API
export const ACTISURE = 'ACTISURE';

//View cases
export const REVIEWSTARTED = "REVIEWSTARTED";
export const REVIEWENDED = 'REVIEWENDED';
export const REVIEWCOMPLETED = 'REVIEWCOMPLETED';
export const REVIEWCANCELLED = 'REVIEWCANCELLED';
export const GOPCANCELLED = 'GOPCANCELLED';
export const REOPENCASE = 'REOPENCASE';
//CONSTANTS
export const graybutton_background = "#5b6770";
export const blue_background = "#164e99";
export const GREEN = "#008000";
export const PURPLE_COLOR = "#001f72";
export const BLUE_COLOR = "#30cdff";
export const WHITE_COLOR = "#ffffff";
export const SPECIAL_BLUE = "#00a3e0";
export const LIGHT_BLUE = "#CBECF9";
export const SPECIAL_RED = "#ed1c24";
export const AZURE_BLUE = "#219bfd";
export const CANARY_YELLOW = "#E68722";
export const LIGHTCANARY_YELLOW = "#f3a536";
export const SPECIAL_GRAY = "#b5b5b5";
export const LIGHT_GRAY = "#edeef1";
export const DISABLED_BACKGROUND_BUTTON = "#d4d4d4";
export const DISABLED_BUTTON_TEXT = "#818181";
export const MODIFIEDBLACK = "#3b4045";
export const isValid_COLORCODE = "#8ba732";
export const isExpiring_COLORCODE = "#f15922";
export const isExpired_COLORCODE = "#821515";

export const datacolor_Health = "#34c3d4";
export const datacolor_Car = "#821515";
export const datacolor_Home = "#0065b3";
export const datacolor_Travel = "#009cdb";
export const datacolor_Boat = "#2a8ca0";
export const datacolor_Others = "#ea216a";
export const datacolor_Life = "#006950";
export const lightGray = "rgba(106, 116, 123, 0.3)";

export const APPROVED_COLOR = "#75D739";
export const ATTENTION_COLOR = "#F5A623";
export const REJECTED_COLOR = "#821515";

export const TERMS_AND_CONDITIONS_GOP =
  "* The guaranteed amount is subject to the terms and conditions of the Policy and the Scale of Costs. In case total expenses exceed that limit, kindly amend GOP at the earliest before proceeding. Please note that this guarantee is based on the present provisional diagnosis.";
export const VERSION_NUMBER =
  "Version 1.0.0";

export const AGENT_CLINIC = "AGENT_CLINIC";
export const AGENT_SWAN = "AGENT_SWAN";
export const AGENT_ADMIN = "AGENT_ADMIN";
export const AGENT_PCL = "AGENT_PCL";

//Case state definitions
export const AWAITING_REVIEW = "AWAITING REVIEW";
export const APPROVED = "APPROVED";
export const NEEDS_ATTENTION = "NEEDS ATTENTION";
export const SEND_ORIGINALS = "SEND ORIGINALS";
export const REJECTED = "REJECTED";
